import { useEffect, useState } from 'preact/hooks'

import { cartProductIds } from '../../helpers/recommendation-settings.mjs'

// helpers/cart.js dispatches this after every getCart(), once window.Cart.value is fresh.
const EVENT_UPDATE_CART_COUNT = 'updateCartCount'

const readCartItems = () => window.Cart?.value?.items ?? window.GM_STATE?.cart?.initCart?.items ?? []

/** Cart product ids as a comma-joined string, kept current as the cart changes. */
export function useCartProductIds() {
  const [ids, setIds] = useState(() => cartProductIds(readCartItems()))

  useEffect(() => {
    const update = () => setIds(cartProductIds(readCartItems()))

    document.addEventListener(EVENT_UPDATE_CART_COUNT, update)
    return () => document.removeEventListener(EVENT_UPDATE_CART_COUNT, update)
  }, [])

  return ids
}
